module.exports = __webpack_public_path__ + "img/Malleolo_LAT_SX.bb596c99.png";